import { z } from "zod";
import { apiBuilder, prefixApi } from "@zodios/core";

const taggerEntityTypeSchema = z.enum(["advertisement", "keyword", "target", "product"]);
export type TaggerEntityType = z.infer<typeof taggerEntityTypeSchema>;

const taggerConditionSchema = z.object({
  field: z.string(),
  operator: z.string(),
  values: z.array(z.number()),
});

const taggerSpecSchema = z
  .object({
    lookback_days: z.number().int(),
    function: z.literal("ADD_TAG"),
    tag_ids: z.array(z.number().int()),
    condition: z.enum(["any", "all", "everything"]),
    conditions: z.array(taggerConditionSchema),
    comment: z.string().optional(),
  })
  .passthrough();

export const taggersApiDefinitions = prefixApi(
  "/api/taggers",
  apiBuilder({
    alias: "getTaggers",
    method: "get",
    path: "/",
    status: 200,
    response: z.record(z.unknown()),
  })
    .addEndpoint({
      alias: "createTagger",
      method: "post",
      path: "/",
      status: 201,
      parameters: [
        {
          name: "body",
          type: "Body",
          schema: z.object({
            name: z.string(),
            marketplace: z.string(),
            entity_type: taggerEntityTypeSchema,
            start_date: z.string(),
            end_date: z.string().nullable().optional(),
            spec: taggerSpecSchema,
          }),
        },
      ],
      response: z.unknown(),
    })
    .addEndpoint({
      alias: "updateTagger",
      method: "put",
      path: "/",
      status: 200,
      parameters: [
        {
          name: "body",
          type: "Body",
          schema: z.object({
            tagger_id: z.number().int(),
            name: z.string().optional(),
            is_enabled: z.boolean(),
            entity_type: taggerEntityTypeSchema,
            spec: taggerSpecSchema.or(z.record(z.unknown())),
            start_date: z.string().optional(),
            end_date: z.string().nullable().optional(),
          }),
        },
      ],
      response: z.record(z.unknown()),
    })
    .addEndpoint({
      alias: "deleteTagger",
      method: "delete",
      path: "/",
      status: 200,
      parameters: [
        {
          name: "body",
          type: "Body",
          schema: z.object({
            tagger_id: z.number().int(),
          }),
        },
      ],
      response: z.record(z.unknown()),
    })
    .build(),
);
